export enum EOrderStatusTabs {
  DETAILS,
  REWARDS,
  RECEIPT,
}
